// extracted by mini-css-extract-plugin
module.exports = {"skipnav":"SkipNav_skipnav__Abaxh","skipnav--Primary":"SkipNav_skipnav--Primary__kRpGo","skipnav--Secondary":"SkipNav_skipnav--Secondary__SvBxE"};